export default __webpack_public_path__ + "static/media/cobertura.5ebb6be9.png";